import { reactive } from 'vue'
import { ESignCommonClient, UserInfo } from './components/esignclient';

export const userStore = reactive({
  loginInfo: new UserInfo()
});

async function loadUser(tenantPublicId: string) {
  userStore.loginInfo = await new ESignCommonClient().getUserInfo(tenantPublicId);
}

export const ensureUser = async (tenantPublicId: string) => {
  if (!userStore.loginInfo.displayName) {
    await loadUser(tenantPublicId);
  }
};

export const refreshUser = async (tenantPublicId: string) => {
  await loadUser(tenantPublicId);
};
